module.exports = __webpack_public_path__ + "static/img/shimingkaoqin.c34b9c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/shimingkaoqin.png
// module id = Go3W
// module chunks = 1